/**
 * PageSelection React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


// react
import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';

// material UI
import IconButton from "@material-ui/core/IconButton/IconButton";
import Typography from '@material-ui/core/Typography';

// icons
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';


/**
 * PageSelection is a simple widget for switching pages
 *
 * @author Jens Gruschel
 */
export function PageSelection(props) {

    if (props.pageCount <= 0) return null;

    const minusButton = <IconButton disabled={props.pageNumber <= 1} onClick={() => props.onChange(props.pageNumber - 1)}>
        <NavigateBeforeIcon/>
    </IconButton>;

    const plusButton = <IconButton disabled={props.pageNumber >= props.pageCount} onClick={() => props.onChange(props.pageNumber + 1)}>
        <NavigateNextIcon/>
    </IconButton>;

    if (props.onLabel) {
        return <div className={props.classes.pageSelection}>
            {minusButton}
            {props.onLabel(props.pageNumber, props.pageCount)}
            {plusButton}
        </div>;
    }

    else {
        return <div className={props.classes.pageSelection}>
            {minusButton}
            <Typography variant="button">{props.pageNumber + "/" + props.pageCount}</Typography>
            {plusButton}
        </div>;
    }
}

PageSelection.propTypes = {
    pageNumber: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    onChange: PropTypes.func,
    onLabel: PropTypes.func,
};

const styles = {
    pageSelection: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }
};

export default withStyles(styles)(PageSelection);